import { SLIDE_DOWN_UP } from "Util/animations";

export default {
    methods: {
        rowClick(index) {
            this.$emit("row-click", index);
        },
        sortClick(index, event) {
            this.$emit("sort-click", index, event);
        },
        helpClick(index, event) {
            event.stopPropagation();
            this.$emit("help-click", index);
        },
        cellClick(colIndex, item) {
            this.$emit("cell-click", colIndex, item);
        },
        getClassObject(column) {
            return {
                "sortable-header": column.orderable,
                "sorting-asc": column.sortingDir === "asc",
                "sorting-desc": column.sortingDir === "desc"
            };
        },
        // We need a unique key for every cell slot, and it must include
        // enough data to uniquely identify the item. Otherwise, when we add to or
        // remove from the source list of items, we may wind up with some cells
        // having stale data or data that corresponds to another item
        getCellKey(rowIndex, colIndex, item) {
            let itemKey = "";
            if (this.keyProp == null || this.keyProp === "") {
                itemKey = JSON.stringify(item);
            } else if (typeof this.keyProp === "string" && item.item[this.keyProp] != null) {
                itemKey = item.item[this.keyProp];
            } else {
                this.keyProp.forEach((kp) => {
                    itemKey += item.item[kp];
                });
            }

            return `row-${rowIndex}-col-${colIndex}-${itemKey}`;
        },
        enter: SLIDE_DOWN_UP.enter,
        leave: SLIDE_DOWN_UP.leave
    },
    props: {
        items: { type: Array, required: true },
        columns: { type: Array, required: true },
        keyProp: { type: [String, Array], required: true },
        showActions: { type: Function, required: true }
    }
};
